import styled from 'styled-components/macro';

export const Container = styled.div`
  margin-bottom: 30px;
  background: white;
  padding: 40px 60px;
`;
